enum TrackingEvents {
  ACCOUNT_ID = 'account_id',
  ACCOUNT_ID_UPDATE = 'account_id_update',
  USER_ID = 'user_id',
  USER_ID_UPDATE = 'user_id_update',
}

export { TrackingEvents };
